import React from 'react';

export default class ExtWindow extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			active: false,
			toggleKey: props.toggleKey ? props.toggleKey : 16 //shift
		}
	}

	componentDidMount() {
		this.handler = _ => {
			if(_.keyCode === this.state.toggleKey)
				this.setState({
					active: !this.state.active
				})
		}
		document.addEventListener('keyup', this.handler)
	}

	componentWillUnmount() {
		document.removeEventListener('keyup', this.handler)
	}

	render() {
		const style = {
			position: 'absolute',
			top: '5vh',
			left: '5%',
			zIndex: 21,
			width: '90%',
			height: '90vh',
			backgroundColor: 'rgba(0,0,0,0.8)',
			boxShadow: '0 0 3px 3px #0a0a0a',
			padding: this.props.nopadding ? '0' : '20px',
			textAlign: 'center',
			boxSizing: 'border-box',
			animation: 'slide-from-bottom ease 1s',
			display: this.state.active ? 'block' : 'none'
		}
		const backdropStyle = {
			position: 'absolute',
			top: 0,
			left: 0,
			zIndex: 20,
			width: '100%',
			height: '100vh',
			backgroundColor: 'rgba(0,0,0,0.5)',
			animation: 'fade-in ease .5s',
			cursor: 'pointer',
			display: this.state.active ? 'block' : 'none'
		}

		return (
			<div className="ext-window-backdrop" style={backdropStyle} onClick={_ => this.setState({active: false})}>
				<div className="ext-window" style={style}>
					{this.props.children}
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/ExtWindow.js